'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Copies text to clipboard by adding/removing hidden element with value
 * https://hackernoon.com/copying-text-to-clipboard-with-javascript-df4d4988697f
 * @param {string} text 
 */
var copyToClipboard = exports.copyToClipboard = function copyToClipboard(text) {
  var el = document.createElement('textarea'); // Create a <textarea> element
  el.value = text; // Set its value to the string that you want copied
  el.setAttribute('readonly', ''); // Make it readonly to be tamper-proof
  el.style.position = 'absolute';
  el.style.left = '-9999px'; // Move outside the screen to make it invisible
  document.body.appendChild(el); // Append the <textarea> element to the HTML document
  el.select(); // Select the <textarea> content
  document.execCommand('copy'); // Copy - only works as a result of a user action (e.g. click events)
  document.body.removeChild(el); // Remove the <textarea> element
};


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui-core/lib/services/ClipboardService.js
// module id = 809
// module chunks = 10